import { apiSlice } from "../../app/api/apiSlice";

export const retryPendingDocumentUploadsApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		retryPendingDocumentUploads: builder.mutation({
			query: ({ loanGuid }) => ({
				url: `/api/v1/loan/retry_pending_document_uploads/${loanGuid}/`,
				method: "POST",
			}),
		}),
	}),
});

export const { useRetryPendingDocumentUploadsMutation } =
	retryPendingDocumentUploadsApiSlice;
